var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { C } from '#integrations';
import { InlineImageTestIdFactory } from './interactions';
import styles from './InlineImage.module.css';
export const InlineImage = ({ alt = '', className, 'data-testid': testid, height, loading = 'eager', src, srcSet, width, }) => (_jsx("img", { alt: alt, className: C(styles.Container, className), "data-testid": InlineImageTestIdFactory.getInlineImageTestId(testid), height: height, loading: loading, ...(alt && { role: 'img' }), src: src, srcSet: srcSet, width: width }));
_react_refresh_temp_1 = InlineImage;
$RefreshReg$(_react_refresh_temp_1, "InlineImage");
